import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { BarChart } from "@mui/x-charts/BarChart";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";

const chartData = [
  { day: "Mon", value: 45 },
  { day: "Tue", value: 52 },
  { day: "Wed", value: 38 },
  { day: "Thu", value: 65 },
  { day: "Fri", value: 58 },
  { day: "Sat", value: 72 },
  { day: "Sun", value: 48 },
];

export default function EnrollmentChart() {
  return (
    <Card sx={{ height: "100%", boxShadow: 0 }}>
      <CardContent>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "start",
            mb: 3,
          }}
        >
          <Box>
            <Typography variant="h6" sx={{ mb: 0.5 }}>
              Enrollment Trend
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Last 7 days
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              color: "#10b981",
            }}
          >
            <TrendingUpIcon sx={{ fontSize: 20 }} />
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              +12.5%
            </Typography>
          </Box>
        </Box>

        <BarChart
          dataset={chartData}
          xAxis={[
            {
              scaleType: "band",
              dataKey: "day",
              categoryGapRatio: 0.5,
            },
          ]}
          series={[
            {
              dataKey: "value",
              color: "#614438",
            },
          ]}
          height={300}
          margin={{ top: 10, bottom: 30, left: 40, right: 10 }}
          sx={{
            "& .MuiBarElement-root": {
              rx: 26,
              ry: 26,
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            },
          }}
        />
      </CardContent>
    </Card>
  );
}
